module.exports = __webpack_public_path__ + "img/grey_029.f6186723.png";